import { EMPTY_LIST } from '../../../../../constants/common'
import {
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_ADD,
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_EDIT,
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
} from '../../../../Entity'
import {
  getRequestEditCategoryModalPayload,
  getRequestPhaseStatus,
  getRequestPhaseStatusText,
  getTooltipAdditionalText,
} from '../../../../Request'
import { RequestProfileHeaderInfoItemName } from '../../../RequestProfileHeaderInfoItem'

export function getRequestProfileHeaderEditCategoryPayload(values) {
  const payload = getRequestEditCategoryModalPayload(values)

  return {
    category: payload?.id ?? null,
  }
}

export function getRequestProfileHeaderInfoItemActions(onClick) {
  return {
    [ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_ADD]: {
      onClick,
    },
    [ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_EDIT]: {
      onClick,
    },
  }
}

export function getRequestProfileHeaderInfoItemsPreparedPhases(data) {
  return (
    data?.map(item => ({
      ...item,
      status: getRequestPhaseStatus(item?.progress),
    })) || EMPTY_LIST
  )
}

export function getRequestProfileHeaderInfoItemsEditCategoryActionTypes() {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return Object.values(actionTypeOptions).filter(item =>
    [
      EntityActionTypeSelectOptionValue.Edit,
      EntityActionTypeSelectOptionValue.RemoveAll,
    ].includes(item.value)
  )
}

export function getRequestProfileHeaderInfoItems({ requestData }) {
  const canEditOwner = Boolean(
    !requestData?.isArchived && requestData?.permissions?.can_edit_owner
  )
  const canEditCategory = requestData?.permissions?.can_edit_content
  const canEditDueDate = Boolean(
    !requestData?.isArchived && requestData?.permissions?.can_edit_due_date
  )
  const canViewDueDate = Boolean(requestData?.permissions?.can_view_due_date)

  return [
    {
      canEdit: canEditDueDate,
      name: RequestProfileHeaderInfoItemName.Deadline,
      value: requestData?.due_date,
    },
    {
      canEdit: canEditOwner,
      name: RequestProfileHeaderInfoItemName.Owner,
      value: requestData?.owner?.id,
    },
    {
      canEdit: canEditCategory,
      name: RequestProfileHeaderInfoItemName.Category,
      value: requestData?.category?.name,
    },
    {
      canEdit: canEditOwner,
      name: RequestProfileHeaderInfoItemName.Building,
      value: requestData?.building?.id,
    },
    {
      canEdit: canEditOwner,
      name: RequestProfileHeaderInfoItemName.Flat,
      value: requestData?.flat?.id,
    },
  ].filter(
    item =>
      item.name !== RequestProfileHeaderInfoItemName.Deadline || canViewDueDate
  )
}

export function getRequestProfileHeaderInfoItemsPhaseListProps() {
  return {
    getPhaseStatusText: getRequestPhaseStatusText,
    getTooltipAdditionalText: getTooltipAdditionalText,
  }
}
